import React, { useEffect, useRef, useState, FC } from 'react'
import { Button, Form, message, Modal, Upload } from 'antd'
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption, IYhFormRef } from "@/components/YhFormBoxVertical/Types";
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, switchNum1, formatNum } from '@/utils/utils'
import { useDictModel } from '@/views/base/dict/dictModel'
import { useSaleDcDetailsModel } from './saleDcDetailsModel'
import { ISCMSaleDcFormFields } from '../../saleDcTypes'
import useGlobalModel from '@/model/globalModel'
import { YhAuth } from '@/components/auth/YhAuth'
import { debounce } from 'lodash'
import { saleDcService } from '../../saleDcService'
import { ResourceAuthEnum } from '@/types/VrmResoureAuthEnum'
import { DictCodeEnmu } from '@/types/VrmSaDictEnums'
import FontIcon from '@/components/YhIcon'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { UploadOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import { fileDownload } from '@/utils/exportFile'
import { UploadFile } from 'antd/lib/upload/interface'
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>()
    const { fetchFmsShopList, beShopDs, shopDs, user: { userName, shopCode }, } = useGlobalModel()
    const { getTreeNodeName } = useDictModel();
    const {
        editFormVal,
        addFormVal,
        editDesc,
        addDesc,
        outWhConfirm,
        buttonControl,
        saveBtnLoading,
        saveBtn,
        setPrint,
        insertSDc,
        updateSDc,
        getSDcDetailOne,
        updateEditFormVal,
        updateAddFormVal,
        resetEditCatch,
        resetAddCatch,
        verifyGoods,
        rejectDc,
        formComputeRule,
        exportSDcdetail,
        setSaveBtnLoading,
        setEditGoodsList,
        setAddGoodsList
    } = useSaleDcDetailsModel()
    const { selectedNavId, replaceNav, findNav } = useNavModel()
    const { getSelectedDictOne } = useDictModel(() => [])
    const [more, setMore] = useState<boolean>(true) //控制更多按钮
    const typeForm: any = {
        add: addFormVal,
        edit: editFormVal,
    }
    //根据状态判断是否可以进行修改 调出单：只有待调出的时候可以修改
    const [isDisabled, setIsDisabled] = useState(false)

    useEffect(() => {
        if (mode === 'add') {
            setIsDisabled(false)
        } else if (mode === 'edit') {
            if (editFormVal?.status !== DictCodeEnmu.TRANSFER_STATUS_INIT) {
                setIsDisabled(true)
            } else {
                setIsDisabled(false)
            }
        } else {
            setIsDisabled(true)
        }
    }, [editFormVal])

    //编辑时， 没有缓在调用详情接口    //回显对应站点核算单位的实体
    useEffect(() => {
        if (mode === 'edit') {
            if (!editFormVal.id) {
                getSDcDetailOne(id)
                //.then((res) => {
                //     getShopOutUnitDetail(res.outShopCode)
                //     getShopInUnitDetail({ label: res.shopName, value: res.shopCode }, true)
                // })
                return
            }
            // editFormVal.shopCode && getShopInUnitDetail({ label: editFormVal.shopName ?? '', value: editFormVal.shopCode }, true)
            // editFormVal.outShopCode && getShopOutUnitDetail(editFormVal.outShopCode)
        }
        // if (mode === 'add') {
        //     addFormVal.shopCode && getShopInUnitDetail({ label: addFormVal.shopName ?? '', value: addFormVal.shopCode }, true)
        //     addFormVal.outShopCode && getShopOutUnitDetail(addFormVal.outShopCode)
        // }
    }, [mode])

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav('16-2-1') && resetAddCatch()
            !findNav('16-2-2') && resetEditCatch()
        }
    }, [selectedNavId])

    //监听商品变化的时候 设置表单金额
    useEffect(() => {
        let values: ISCMSaleDcFormFields = formRef.current?.getFieldsValue()
        setFormAmount(values)
    }, [addDesc, editDesc])

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    /**
     * 表单或者商品操作
     */
    const setFormAmount = (values: ISCMSaleDcFormFields, changedValues?: { [key: string]: any }) => {
        let { amountAll, actualAmount } = mode === 'edit' ? editDesc : addDesc
        let {
            favorableAmount, //整单优惠
            discountRate, //整单下浮
            aggregateAmount, //应付金额
            paidAmount, //已付金额
            discountTotalAmount, //优惠总额
        } = values
        discountRate = switchNum1(discountRate, '0')
        favorableAmount = switchNum1(favorableAmount, '0')
        actualAmount = +formatNum(actualAmount)
        amountAll = +formatNum(amountAll)
        //应付金额=sum(总计)*（1-整单下浮）-整单优惠）
        let isZero = +formatNum(amountAll * (1 - +discountRate) - +favorableAmount)
        aggregateAmount = isZero < 0 ? `-${isZero}` : isZero

        //优惠总额 = 所有商品的合计 - 总计 - 整单优惠 - 整单下浮优惠
        discountTotalAmount = formatNum(actualAmount - isZero)

        paidAmount = formatNum(paidAmount)
        // setWsConfirmDisable(true);
        saveCache(changedValues ? changedValues : { discountTotalAmount, aggregateAmount, favorableAmount, discountRate, paidAmount })
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        if ('favorableAmount' in changedValues || 'discountRate' in changedValues) {
            setFormAmount(values)
        } else {
            setFormAmount(values, { ...changedValues })
        }
    }

    //表单提交
    const onSubmit = () => {
        if (!verifyGoods(mode)) return
        if (!formComputeRule(mode)) return

        formRef.current
            ?.validateFields()
            .then((val: any) => {
                const { fileList = [] } = val
                if (fileList.length > 0) {
                    const file = fileList[0]
                    if (!file?.uid) {
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    val.outMd5 = file?.uid
                    val.outName = file?.name
                } else {
                    val.outMd5 = ''
                    val.outName = ''
                }
                val.fileList = null
                mode === 'edit'
                    ? updateSDc(val)
                    : insertSDc(val).then((res) => {
                        if (res) {
                            resetEditCatch()
                            replaceNav('16-2-1', '16-2-2', { id: res, mode: 'edit' })
                        }
                    })
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }

    //回显选中调出站点带出来的数据
    const [outUnitBeList, setOutUnitBeList] = useState<ISelectOption[]>([]) //调出站点对应的关联实体
    const getShopOutUnitDetail = async (shopId: string) => {
        let { retData } = await saleDcService.queryShopUnitBe(shopId as string)
        if (retData && retData.id) {
            if (retData.bentityList && retData.bentityList.length) {
                setOutUnitBeList(retData.bentityList.map((item) => ({ label: item.name ?? '', value: item.code ?? '' })))
            } else {
                setOutUnitBeList([])
                message.warning('调出站点对应的核算单位没有关联实体')
            }
        } else {
            setOutUnitBeList([])
            message.warning('调出站点没有关联的核算单位')
        }
    }

    const [inUnitBeList, setInUnitBeList] = useState<ISelectOption[]>([]) //调入站点对应的关联实体
    //回显选中调入站点带出来的数据
    const getShopInUnitDetail = async (option: ISelectOption, echo: boolean = false) => {
        let { retData } = await saleDcService.queryShopUnitBe((option.id as string) ?? (option.value as string))
        let data = {
            shopCode: option.value,
            shopName: option.label,
            shopId: option.id,
            transferTypeName: option.branch === 'scm' ? '备品调拨' : '其它调拨',
            transferTypeCode: option.branch === 'scm' ? DictCodeEnmu.TRANSFER_TYPE_BP : DictCodeEnmu.TRANSFER_TYPE_OTHERS,
            bentityName: undefined, //每次选中的时候对应的实体置空
            bentityCode: undefined,
            contact: undefined,
            phone: undefined,
            branchIn: option.branch,
        }
        if (retData && retData.id) {
            if (retData.bentityList && retData.bentityList.length) {
                setInUnitBeList(retData.bentityList.map((item) => ({ label: item.name ?? '', value: item.code ?? '' })))
            } else {
                setInUnitBeList([])
                message.warning('调入站点对应的核算单位没有关联实体')
            }
            //回显时不用执行一下操作
            if (echo) return
            saveCache({
                ...data,
                contact: retData.contact,
                phone: retData.phone,
            })
        } else {
            saveCache(data)
            setOutUnitBeList([])
            message.warning('调入站点没有关联的核算单位')
        }
    }
    //调入站点
    const inShopChange = (value: string, option: ISelectOption) => {
        mode === 'add' ? setAddGoodsList([]) : setEditGoodsList([])
        if (option && option.value) {
            saveCache({
                shopCode: option.code,
                shopName: option.label,
                shopId: option.value,
            })
        }
    }

    //调出实体
    const outBeChange = (value: string, option: ISelectOption) => {
        option && saveCache({ outBentityName: option.label, outBentityCode: option.value })
    }
    //调入实体
    const inBeChange = (value: string, option: ISelectOption) => {
        option && saveCache({ bentityName: option.label, bentityCode: option.value })
    }
    //调拨类行
    const transferTypeChange = (value: string, option: ISelectOption) => {
        option && saveCache({ transferTypeName: option.label, transferTypeCode: option.value })
    }

    const onRefresh = debounce(() => {
        getSDcDetailOne(id).then((res) => message.success('已刷新'))
    }, 500)

    const whConFirm = () => {
        if (!verifyGoods(mode)) return
        formRef.current
            ?.validateFields()
            .then((val: any) => {
                const { fileList = [] } = val
                if (fileList.length > 0) {
                    const file = fileList[0]
                    if (!file?.uid) {
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    val.outMd5 = file?.uid
                    val.outName = file?.name
                } else {
                    val.outMd5 = ''
                    val.outName = ''
                }
                val.fileList = null
                outWhConfirm(val)
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }

    const rightChildren = (
        <>
            {mode === 'edit' && (
                <>
                    {/* <Button className="mr-5" type="primary" shape="round" onClick={() => exportSDcdetail()}>
                        导出
                    </Button> */}
                    <YhAuth resCode={ResourceAuthEnum.S_DC_ED_PRINT}>
                        <Button className="mr-5" type="primary" shape="round" onClick={() => setPrint(true)}>
                            打印
                        </Button>
                    </YhAuth>
                    <Button className="mr-5" type="primary" shape="round" onClick={onRefresh}>
                        刷新
                    </Button>
                    <YhAuth resCode={ResourceAuthEnum.S_DC_ED_REJECT}>
                        <Button className="mr-5" type="primary" shape="round" onClick={() => rejectDc()}>
                            驳回
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.S_DC_ED_DC}>
                        <Button
                            className="mr-5"
                            type="primary"
                            shape="round"
                            disabled={editFormVal.status !== DictCodeEnmu.TRANSFER_STATUS_INIT || saveBtn}
                            onClick={debounce(() => {
                                whConFirm()
                            })}
                        >
                            调出
                        </Button>
                    </YhAuth>
                </>
            )}
            <YhAuth resCode={mode === 'edit' ? ResourceAuthEnum.S_DC_ED_SAVE : ResourceAuthEnum.S_DC_AD_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveBtnLoading}
                    onClick={debounce(() => {
                        onSubmit()
                    }, 500)}
                >
                    {saveBtnLoading ? '保存中' : '保存'}
                </Button>
            </YhAuth>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => {
                    replaceNav(selectedNavId, '16-2')
                    setSaveBtnLoading(false)
                }}
            >
                返回
            </Button>
        </>
    )

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>, branch = "vrm") => {
        const { uid, name } = file
        const type = name.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={branch !== 'ci' ? getBaseImgLookUrl(uid) : `https://file-server.yunhaochefu.com/image/${uid}`} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    const [shopList, setShopList] = useState<ISelectOption[]>([])
    useEffect(() => {
        fetchFmsShopList('').then(arr => {
            setShopList(arr)
        })
    }, [])
    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        items: [
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '调出单号',
            //     fieldName: 'code',
            //     disable: true,
            //     placeholder: '自动生成',
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调入站点',
                fieldName: 'shopCode',
                onSelectChange: inShopChange,
                rules: [{ required: true, message: '请选择调入站点' }],
                disable: mode === 'edit',
                options: shopDs.map((item: any) => {
                    if (shopCode == item.code) {
                        return { ...item, disabled: true }
                    } else {
                        return item
                    }
                }),
                // selectfetchList: fetchFmsShopList,
                // options: shopList.map(item => {
                //     if (shopCode == item.code) {
                //         return { ...item, disabled: true }
                //     } else {
                //         return item
                //     }
                // }),
                // defaultQuery: mode === 'edit' ? editFormVal.shopName: addFormVal.shopName,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '整单下浮',
                fieldName: 'discountRate',
                disable: mode === 'edit' && editFormVal.status !== DictCodeEnmu.TRANSFER_STATUS_INIT,
                rules: [
                    { required: true, message: '该项为必填' },
                    { pattern: /^0\.[0-9]{1,2}$|^0{1}$|^1{1}$|^1\.[0]{1,2}$/, message: '请输入0-1' },
                ],
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '应付金额',
                fieldName: 'aggregateAmount',
                disable: true,
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出站点',
                fieldName: 'outShopName',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出备注',
                fieldName: 'note',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入员',
                fieldName: 'transferIn',
                disable: true,
                // hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出员',
                fieldName: 'transferOut',
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '制单员',
                fieldName: 'applier',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调入实体',
                fieldName: 'bentityCode',
                options: beShopDs,
                onSelectChange: inBeChange,
                disable: mode === 'edit' && editFormVal.status !== DictCodeEnmu.TRANSFER_STATUS_INIT,
                rules: [{ required: true, message: '请选择调入实体' }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调出实体',
                fieldName: 'outBentityCode',
                onSelectChange: outBeChange,
                options: beShopDs,
                disable: mode === 'edit' && editFormVal.status !== DictCodeEnmu.TRANSFER_STATUS_INIT,
                rules: [{ required: true, message: '请选择调出实体' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入备注',
                fieldName: 'inNote',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入日期',
                fieldName: 'transferInTime',
                disable: true,
            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出日期',
                fieldName: 'transferOutTime',
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '制单日期',
                fieldName: 'applyTime',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '调拨类型',
                fieldName: 'transferTypeCode',
                onSelectChange: transferTypeChange,
                options: getSelectedDictOne(DictCodeEnmu.TRANSFER_TYPE),
                disable: true,
                rules: [{ required: true, message: '请选择调拨类型' }],
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'inMd5',
                colClassName: 'ant-col-h-auto',
                span: 12,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            disabled={isDisabled}
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file: any) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                    file.status = 'done'
                                }
                                // return isType && isLt20M
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )
                            }}
                        >
                            {!isDisabled && (
                                <>
                                    <Button icon={<UploadOutlined />}>选择文件上传</Button>
                                    <span style={{ lineHeight: '25px', color: 'green', fontSize: '13px', marginLeft: '10px' }}>提醒：上传单个文件不能超过20M,当前仅.jpg", ".png", ".jpeg", "svg", ".gif", ".pdf", ".doc等任何类型文件</span>
                                </>
                            )}
                        </Upload>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '调入附件',
                fieldName: 'inMd5',
                colClassName: 'ant-col-h-auto',
                span: 12,
                hidden: mode === 'add',
                formItem: (
                    <Form.Item name="fileInList" label="调入附件" valuePropName="fileInList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        {editFormVal.fileInList && (editFormVal.fileInList.length > 0) &&
                            <div style={{ position: 'relative', height: '66px', padding: '20px', border: '1px solid #90a4fe', borderRadius: '5px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                onClick={() => {
                                    onPreview(editFormVal.fileInList[0], mode === 'edit' ? editFormVal.branchIn : addFormVal.branchIn)
                                }}
                            >
                                <FontIcon
                                    style={{ fontSize: '24px' }}
                                    type="icon-tupian"
                                />
                                <span style={{ marginLeft: '20px' }}>{editFormVal.fileInList[0].name}</span>
                            </div>}
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '整单优惠',
                fieldName: 'favorableAmount',
                disable: mode === 'edit' && editFormVal.status !== DictCodeEnmu.TRANSFER_STATUS_INIT,
                rules: [{ pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数' }],
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '已付金额',
                fieldName: 'paidAmount',
                disable: true,
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '优惠总额',
                fieldName: 'discountTotalAmount',
                hidden: true,
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "联系人",
                //     fieldName: "contact",
                //     disable: mode === "edit" && editFormVal.status !== DictCodeEnmu.TRANSFER_STATUS_INIT,
                //     rules: [{ required: true, message: "请输入联系人" }]

                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "联系电话",
                //     fieldName: "phone",
                //     disable: mode === "edit" && editFormVal.status !== DictCodeEnmu.TRANSFER_STATUS_INIT,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '制单人',
                fieldName: 'createUser',
                disable: true,
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改人',
                fieldName: 'updateUser',
                disable: true,
                hidden: true,
                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "制单日期",
                //     fieldName: "createTime",
                //     disable: true,
                //     hidden: more

                // }, {
                //     type: FormItemTypeEnum.Input,
                //     fieldLabel: "修改日期",
                //     fieldName: "updateTime",
                //     disable: true,
                //     hidden: more
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'bentityName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出站点Code',
                fieldName: 'outShopCode',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入站点名称',
                fieldName: 'shopName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入站点id',
                fieldName: 'shopId',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出站点id',
                fieldName: 'outShopId',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出实体名称',
                fieldName: 'outBentityName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调拨类型名称',
                fieldName: 'transferTypeName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入分支',
                fieldName: 'branchIn',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出分支',
                fieldName: 'branchOut',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '状态',
                fieldName: 'status',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调出单号',
                fieldName: 'transferOutCode',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入单号',
                fieldName: 'transferInCode',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '成本金额',
                fieldName: 'costAmount',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '毛利',
                fieldName: 'grossProfit',
                hidden: true,
            },
        ],
    }

    const poFromConfig: IYhFormBox<ISCMSaleDcFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'edit' ? editFormVal : addFormVal,
        onChange,
        boxs: [baseFormItem],
        disabled: isDisabled,
    }

    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        调出单号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].code ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}
